import React from "react"
import { IconProps } from "@chakra-ui/react"
import { GUEST_LIST_ICONS, StarIcon, TagIcon } from "./icons"

// Legacy data shipped by the Rails app before the curated icon set existed.
// VIP rows created pre-Sep-2025 are stored as `icon: "vip"` (a pink star in
// the old IcoMoon sprite). Map to the curated StarIcon so they keep rendering.
const LEGACY_ALIASES: Record<string, typeof TagIcon> = {
  vip: StarIcon,
}

// Matches the legacy `gray.500` icon color so a row with no color set looks
// identical to an uncustomized tag from before the feature shipped. Exported
// so the picker can seed `initialValues.color` with the same default.
export const DEFAULT_GUEST_LIST_COLOR = "#9E9E9E"
export const DEFAULT_GUEST_LIST_ICON = "tag"

type Props = {
  icon?: string | null
  color?: string | null
} & Omit<IconProps, "color">

const GuestListIcon = ({ icon, color, ...rest }: Props) => {
  const Component = (icon ? (GUEST_LIST_ICONS[icon] ?? LEGACY_ALIASES[icon]) : undefined) ?? TagIcon

  return <Component color={color ?? DEFAULT_GUEST_LIST_COLOR} {...rest} />
}

export default GuestListIcon
